// extracted by mini-css-extract-plugin
export default {"StickyBlock":"bfc_a bic_bj"};